import { render, staticRenderFns } from "./AskProduct.vue?vue&type=template&id=2010976a"
import script from "./AskProduct.vue?vue&type=script&lang=ts"
export * from "./AskProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports